// usePlatformPayouts — TanStack Query hook for /v1/platform/payouts.
//
// Admin-only. 30s background poll so the status column ticks live as the
// reconciler resolves pending rows — same pattern as the merchant-side
// payouts list.
import { useQuery } from "@tanstack/react-query";

import { listPlatformPayouts } from "@/api/platformPayouts";
import { useAuth, isAdminRole } from "@/store/auth";

export function usePlatformPayouts() {
  const status = useAuth((s) => s.status);
  const isAdmin = useAuth((s) => isAdminRole(s.user?.role));

  return useQuery({
    queryKey: ["platform-payouts"],
    queryFn: listPlatformPayouts,
    enabled: status === "authenticated" && isAdmin,
    // AUDIT-PASS-10 FE-M12: staleTime matches refetchInterval. Originally
    // staleTime was 10s and refetchInterval was 30s, which produced an
    // extra mount-time refetch every time the user navigated to the page
    // after the 10s window expired (on top of the scheduled 30s poll).
    // Matching the two means TanStack only refetches on the scheduled
    // tick — admin volume is low and tighter freshness has no operator
    // value here.
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
